// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/powersensor/v1/powersensor.proto" (package "viam.component.powersensor.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { GetReadingsResponse } from "../../../common/v1/common";
import { GetReadingsRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.powersensor.v1.GetVoltageRequest
 */
export interface GetVoltageRequest {
    /**
     * Name of a power sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.powersensor.v1.GetVoltageResponse
 */
export interface GetVoltageResponse {
    /**
     * Voltage in volts
     *
     * @generated from protobuf field: double volts = 1;
     */
    volts: number;
    /**
     * Bool describing whether the voltage is DC or AC
     *
     * @generated from protobuf field: bool is_ac = 2;
     */
    isAc: boolean;
}
/**
 * @generated from protobuf message viam.component.powersensor.v1.GetCurrentRequest
 */
export interface GetCurrentRequest {
    /**
     * Name of a power sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.powersensor.v1.GetCurrentResponse
 */
export interface GetCurrentResponse {
    /**
     * Current in amperes
     *
     * @generated from protobuf field: double amperes = 1;
     */
    amperes: number;
    /**
     * Bool descibing whether the current is DC or AC
     *
     * @generated from protobuf field: bool is_ac = 2;
     */
    isAc: boolean;
}
/**
 * @generated from protobuf message viam.component.powersensor.v1.GetPowerRequest
 */
export interface GetPowerRequest {
    /**
     * Name of a power sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.powersensor.v1.GetPowerResponse
 */
export interface GetPowerResponse {
    /**
     * Power in watts
     *
     * @generated from protobuf field: double watts = 1;
     */
    watts: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetVoltageRequest$Type extends MessageType<GetVoltageRequest> {
    constructor() {
        super("viam.component.powersensor.v1.GetVoltageRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.powersensor.v1.GetVoltageRequest
 */
export const GetVoltageRequest = new GetVoltageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVoltageResponse$Type extends MessageType<GetVoltageResponse> {
    constructor() {
        super("viam.component.powersensor.v1.GetVoltageResponse", [
            { no: 1, name: "volts", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "is_ac", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.powersensor.v1.GetVoltageResponse
 */
export const GetVoltageResponse = new GetVoltageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentRequest$Type extends MessageType<GetCurrentRequest> {
    constructor() {
        super("viam.component.powersensor.v1.GetCurrentRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.powersensor.v1.GetCurrentRequest
 */
export const GetCurrentRequest = new GetCurrentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentResponse$Type extends MessageType<GetCurrentResponse> {
    constructor() {
        super("viam.component.powersensor.v1.GetCurrentResponse", [
            { no: 1, name: "amperes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "is_ac", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.powersensor.v1.GetCurrentResponse
 */
export const GetCurrentResponse = new GetCurrentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPowerRequest$Type extends MessageType<GetPowerRequest> {
    constructor() {
        super("viam.component.powersensor.v1.GetPowerRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.powersensor.v1.GetPowerRequest
 */
export const GetPowerRequest = new GetPowerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPowerResponse$Type extends MessageType<GetPowerResponse> {
    constructor() {
        super("viam.component.powersensor.v1.GetPowerResponse", [
            { no: 1, name: "watts", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.powersensor.v1.GetPowerResponse
 */
export const GetPowerResponse = new GetPowerResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.powersensor.v1.PowerSensorService
 */
export const PowerSensorService = new ServiceType("viam.component.powersensor.v1.PowerSensorService", [
    { name: "GetVoltage", options: { "google.api.http": { get: "/viam/api/v1/component/power_sensor/{name}/voltage" } }, I: GetVoltageRequest, O: GetVoltageResponse },
    { name: "GetCurrent", options: { "google.api.http": { get: "/viam/api/v1/component/power_sensor/{name}/current" } }, I: GetCurrentRequest, O: GetCurrentResponse },
    { name: "GetPower", options: { "google.api.http": { get: "/viam/api/v1/component/power_sensor/{name}/power" } }, I: GetPowerRequest, O: GetPowerResponse },
    { name: "GetReadings", options: { "google.api.http": { get: "/viam/api/v1/component/power_sensor/{name}/readings" } }, I: GetReadingsRequest, O: GetReadingsResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/power_sensor/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/power_sensor/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse }
]);
